export enum PostStatus {
    PUBLISHED = 'published',
    DECLINED = 'declined',
    LIMITED = 'limited',
    DRAFT = 'draft',
    DELETED = 'deleted',
    MODERATION = 'moderation',
}

export enum PostSource {
    MANUAL = 'manual',
    INSTAGRAM = 'instagram',
    TELEGRAM = 'tg',
}
